import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {licensesFeatureKey, LicensesState} from "./licenses.reducer";

export const getLicensesState = createFeatureSelector<LicensesState>(licensesFeatureKey);

export const getLicenses = createSelector(getLicensesState, (state) => state.data);
export const getLicensesLoading = createSelector(getLicensesState, SelectorUtil.isLoading);
